import { Button, Card, Stack, Typography } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { makeInvisible as invisibleZones, clearDestinationZones, clearSourceZones } from "Redux/zonesSlice";
import { makeInvisible as invisibleSurveys } from "Redux/surveysSlice";
import { makeInvisible as invisiblePaths } from "Redux/servicesSlice";
import { makeInvisible as invisibleLocationData } from "Redux/locationDataSlice";
import { makeInvisible as invisibleStations } from "Redux/stationsSlice";
import { makeInvisible as invisibleFilters } from "Redux/filtersSlice";
import { changeLayer } from "Redux/layerControlSlice";

export default function Delete({ setActiveOptionIndex }: { setActiveOptionIndex: (val: number | null) => void }) {
  const dispatch = useAppDispatch();

  const handleDeleteAllFilters = () => {
    setActiveOptionIndex(null);
    dispatch(invisibleSurveys());
    dispatch(invisiblePaths());
    dispatch(invisibleLocationData());
    dispatch(invisibleStations());
    dispatch(invisibleZones());
    dispatch(clearDestinationZones());
    dispatch(clearSourceZones());
    dispatch(invisibleFilters());
    dispatch(changeLayer({ zoneLayer: 14, stationLayer: 13, pathLayer: 12, survayLayer: 11 }));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography>بازگشت به حالت پیشفرض</Typography>

        <Stack direction="row" spacing={1}>
          <Button onClick={() => setActiveOptionIndex(null)} size="large" sx={{ p: 0 }}>
            <CloseOutlinedIcon />
          </Button>
          <Button onClick={handleDeleteAllFilters} size="large" color="error" variant="contained" sx={{ p: 0 }}>
            <DoneOutlinedIcon />
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}
